import { createReducer, on } from '@ngrx/store';
import { NotificationsDrawerActions } from '@capital-access/notifications/drawer';
import { initialCountState, NotificationsCountState } from './notifications-count.state';

export const notificationsCountReducer = createReducer<NotificationsCountState>(
  initialCountState,

  on(NotificationsDrawerActions.loadNotificationCount, state => ({
    ...state,
    loading: true
  })),

  on(NotificationsDrawerActions.loadNotificationCountSuccess, (state, { unreadCount }) => ({
    ...state,
    loading: false,
    unreadCount
  })),

  on(NotificationsDrawerActions.loadNotificationCountFailure, state => ({
    ...state,
    loading: false
  })),

  // When the drawer is opened, sync badge count from the grouped response
  on(NotificationsDrawerActions.loadNotificationsSuccess, (state, { response }) => ({
    ...state,
    unreadCount: response.unreadCount
  })),

  // Decrement badge when an unread notification is deleted
  on(NotificationsDrawerActions.deleteNotificationSuccess, (state, { wasUnread }) => ({
    ...state,
    unreadCount: wasUnread && state.unreadCount > 0 ? state.unreadCount - 1 : state.unreadCount
  })),

  // Decrement badge when a notification is marked as read
  on(NotificationsDrawerActions.markAsReadSuccess, state => ({
    ...state,
    unreadCount: state.unreadCount > 0 ? state.unreadCount - 1 : 0
  }))
);
